
import { h7ProductImage } from '@/utils/h7ComparisonProducts'

export default {
  name: 'H7ComparisonHero',
  props: {
    products: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentYear: new Date().getFullYear(),
    }
  },

  computed: {
    allProducts() {
      return this.products
        .filter(product => product?.variant)
        .map(product => ({
          id: product.id,
          slug: product.slug,
          name: product.name,
          imageUrl: h7ProductImage(product.variant, 300),
        }))
    },
  },
}
